export default __webpack_public_path__ + "static/media/linkedin_icon.687bfc73.png";